import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import './Charts.css';

const GroupedBarChartWidget = ({ data, title, bars = [], nameKey = 'name' }) => {
  if (!data || data.length === 0) {
    return (
      <div className="chart-card">
        <h3>{title}</h3>
        <div className="chart-empty">Sin datos</div>
      </div>
    );
  }

  const defaultBars = [
    { dataKey: 'input', name: 'Entrada', color: '#0088FE' },
    { dataKey: 'output', name: 'Salida', color: '#00C49F' },
    { dataKey: 'total', name: 'Total', color: '#FFBB28' }
  ];

  const barsConfig = bars.length > 0 ? bars : defaultBars;

  return (
    <div className="chart-card">
      <h3>{title}</h3>
      <div className="chart-container">
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data} layout="vertical" margin={{ left: 20, right: 20 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" tickFormatter={(value) => value.toLocaleString()} />
            <YAxis type="category" dataKey={nameKey} width={120} tick={{ fontSize: 11 }} />
            <Tooltip formatter={(value) => value.toLocaleString()} />
            <Legend wrapperStyle={{ paddingTop: '10px' }} />
            {barsConfig.map((bar) => (
              <Bar
                key={bar.dataKey}
                dataKey={bar.dataKey}
                name={bar.name}
                fill={bar.color}
                radius={[0, 2, 2, 0]}
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default GroupedBarChartWidget;
